// extracted by mini-css-extract-plugin
module.exports = {"footer":"App_footer__3csul"};